<template>
    <PrimaryModal
        ref="listQuittancesModal"
        :width="750"
        :btnDismiss="false"
        btnSuccessText="Fermer"
        @ok="$refs.listQuittancesModal.dismissModal()"
    >
        <template v-slot:title>
            <div class="flex justify-between items-center">
                <h3 class="text-2xl text-bold">Listes des quittances</h3>
            </div>
        </template>
        <template v-if="loaded" v-slot:content>
            <table class="w-full">
                <thead>
                    <tr class="">
                        <th scope="col" class="text-left py-2 px-2 text-sm font-normal rtl:text-right text-gray-500">
                            Date de création
                        </th>
                        <th scope="col" class="text-left py-2 px-2 text-sm font-normal rtl:text-right text-gray-500">
                            Nom
                        </th>
                        <th scope="col" class="text-left py-3.5 px-2 flex justify-end items-center">
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <template
                        v-if="quittances && quittances.length !== 0"
                    >
                        <template
                            v-for="quittance of quittances" :key="quittance.uuid"
                        >
                            <QuittanceItem 
                                :quittance="quittance" 
                                :loyerUuid="loyerUuid"
                            />
                        </template>

                    </template>
                    <tr
                        class="px-2 py-3 border-t border-gray-200"
                        v-else-if="!loaded"
                    >
                        <td colspan="5">
                            <SpinnerLoader class="mt-5"></SpinnerLoader>
                        </td>
                    </tr>
                    <tr
                        class="px-2 py-3 border-t border-gray-200"
                        v-else
                    >
                        <td colspan="5" class="text-center">
                            <p class="text-sm text-indigo-400 my-4">Aucune quittance n'a été trouvé.</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>
        <template v-else v-slot:content>
            <SpinnerLoader class="mt-5"></SpinnerLoader>
        </template>
    </PrimaryModal>
</template>

<script>

import SpinnerLoader from './../../../../loader/SpinnerLoader';
import PrimaryModal from './../../../../composant/PrimaryModal';
import QuittanceItem from './QuittanceItem'

export default {
    components: {
        PrimaryModal,
        SpinnerLoader,
        QuittanceItem
    },
    data() {
        return {
            quittances: [],
            loaded: false
        }
    },

    props: {
        loyerUuid: {
            type: String,
        }
    },

    methods: {
        async openModal(quittances = null) {
            this.$refs.listQuittancesModal.openModal();
            this.quittances = quittances

            this.loaded = true
        },
    }
};
</script>